export default "__VITE_ASSET__DivrqQQd__"